<template>
  <div class="USDT_dialog">
    <vDialog :visible.sync="visible" :visibleFooter="false" class="USDTPopup" :top="'150px'" :width="'640px'">
      <div class="USDTPopupContent">
        <div class="body_image">
          <img src="@/assets/images/promotions/usdt/buy-crypto.png" alt />
        </div>
        <div class="body_info body_title" v-html="$t(`deposit.depositBonus.title${computedCampaignName}`)"></div>
        <div class="body_info" v-html="$t(`deposit.depositBonus.body${computedCampaignName}`)"></div>
        <div>
          <el-checkbox v-model="isAgreeOptInTnc" data-testid="checkbox" class="agreeTnc mb-3 text-xs">
            <i18n path="promotion.common.agreeTnc">
              <template v-slot:link>
                <a :href="tncLink" target="_blank" data-testid="tnc">{{ $t('promotion.common.tnc') }}</a>
              </template>
            </i18n>
            <div v-if="showCheckboxError" class="text-warn pt-1">{{ $t('common.formValidation.tnc') }}</div>
          </el-checkbox>
        </div>

        <div class="btn_box">
          <el-button @click="optInClick" class="optIn_btn">
            {{ $t('deposit.crypto.USDT.optIn') }}
          </el-button>
        </div>
        <div class="not_show_again" @click="notShowAgain">{{ $t('deposit.crypto.USDT.notShowAgain') }}</div>
      </div>
    </vDialog>
  </div>
</template>

<script>
import vDialog from '@/components/home/vDialog';
import { apiCampaignInfo } from '@/resource';

export default {
  name: 'DepositBonusDialog',
  props: {
    depositDialogVisible: Boolean,
    campaignName: { type: String, default: null }
  },
  components: { vDialog },
  data() {
    return {
      visible: false,
      check: false,
      isAgreeOptInTnc: false,
      showCheckboxError: false,
      availableCampaignIds: [6, 7, 17, 5049], //6 = Welcome5020, 7 = 	ROW Welcome5010, 17 = Welcome2010, 5049 = 	APAC Welcome5010
      tncLink: undefined
    };
  },
  mounted() {},
  watch: {
    depositDialogVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:depositDialogVisible', bool);
    }
  },
  methods: {
    optInClick() {
      if (this.isAgreeOptInTnc) {
        this.showCheckboxError = false;
        this.$emit('optInClick');
      } else {
        this.showCheckboxError = true;
      }
    },
    notShowAgain() {
      this.$emit('notShowAgain');
    },
    async getDepositBonusTnc() {
      if (this.campaignID) {
        try {
          const response = await apiCampaignInfo(this.campaignID, this.langUsed);
          if (response.data.code === 0 && response.data.data) {
            const tempCpSetting = response.data.data.clientPortalSettings;
            this.tncLink = tempCpSetting.tncLink;
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  computed: {
    computedCampaignName() {
      if (!this.eligibleCampaignIds) return null;
      for (const campaign of this.availableCampaignIds) {
        //check if 5010/5020/2010 is in eligible campaigns
        if (this.eligibleCampaignIds.includes(campaign)) {
          switch (campaign) {
            case 6:
              return 'Welcome5020';
            case 7:
            case 5049:
              return 'Welcome5010';
            case 17:
              return 'Welcome2010';
          }
        }
      }
      return null;
    },
    eligibleCampaignIds() {
      return this.$store.state.promotion.eligibleCampaigns.reduce((acc, i) => {
        if (i.campaignType === 'DEPOSIT_BONUS_2') {
          acc.push(i.id);
        }
        return acc;
      }, []);
    },
    campaignID() {
      let campaign = this.$store.state.promotion.eligibleCampaigns.find(
        c => c.campaignType === 'DEPOSIT_BONUS_2' && this.availableCampaignIds.includes(c.id)
      );
      return campaign ? campaign.id : null;
    },
    langUsed() {
      return this.$store.state.common.lang;
    }
  },
  mounted() {
    this.getDepositBonusTnc();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/deposit/usdtDialog.scss';
</style>
